import React from 'react';

interface Badge {
  icon: string;
  text: string;
}

interface TrustBadgesProps {
  badges?: Badge[];
}

export const TrustBadges: React.FC<TrustBadgesProps> = ({
  badges = [
    { icon: 'license', text: 'Licensed & Insured' },
    { icon: 'warranty', text: '25 Year Warranty' },
    { icon: 'reviews', text: '500+ 5-Star Reviews' },
    { icon: 'experience', text: '25+ Years Experience' }
  ]
}) => {
  const getIcon = (iconType: string) => {
    switch(iconType) {
      case 'license':
        return '🏆';
      case 'warranty':
        return '✓';
      case 'reviews':
        return '⭐';
      case 'experience':
        return '📅';
      default:
        return '✓';
    }
  };

  return (
    <section className="nai-trust-badges">
      <div className="container">
        <div className="nai-trust-badges__grid">
          {badges.map((badge, index) => (
            <div key={index} className="nai-trust-badges__item">
              <span className="nai-trust-badges__icon">{getIcon(badge.icon)}</span>
              <span className="nai-trust-badges__text">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};